import PanicContent from 'Containers/PanicContent';

function AccessDenied() {
  return <PanicContent type="401" />;
}

export default AccessDenied;
